import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'peps-title',
	imports: [

	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './title.component.html',
})
export class TitleComponent {

	@Input() title: string = '';
	@Input() subtitle: string = '';

}
